import { Component, OnInit } from '@angular/core';

import { UserUnlockService } from '@login/services/user-unlock.service';
import { AlertService } from '@shared/services/alert.service';
import { HarpValidators } from '@shared/utils/validators';
import { InputConfig } from '@shared/models/input-config.model';
import { INPUT_CONFIGS, REGEX, TEXT_CONSTANTS } from '@shared/constants';
import { SpinnerService } from '@shared/services/spinner.service';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
@Component({
  selector: 'app-account-locked',
  templateUrl: './account-locked.component.html',
  styleUrls: ['./account-locked.component.scss'],
})
export class AccountLockedComponent implements OnInit {
  isUnlockEmailSent = false;

  unlockAccountForm: UntypedFormGroup;
  emailInputConfig: InputConfig;

  constructor(
    private userUnlockService: UserUnlockService,
    private spinnerService: SpinnerService,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.unlockAccountForm = this.fb.group({
      email: [
        '',
        [
          HarpValidators.required(
            TEXT_CONSTANTS.ERROR_MESSAGE_REQUIRED('Email'),
          ),
          HarpValidators.pattern(REGEX.EMAIL_REGEX, 'Email is invalid'),
        ],
      ],
    });

    this.emailInputConfig = INPUT_CONFIGS.EMAIL({
      form: this.unlockAccountForm,
    });
  }

  unlockUser() {
    const { email } = this.unlockAccountForm.value;

    this.spinnerService.start('Processing...');
    this.userUnlockService.sendUnlockEmail(email).subscribe(
      (result: any) => {
        this.isUnlockEmailSent = true;
        this.spinnerService.stop();
      },
      (error: any) => {
        this.alertService.setAlert(
          error.error.errorMessage ||
            'An unexpected network error has occurred. Please try again later.',
        );
        this.spinnerService.stop();
      },
    );
  }
}
